module.exports = __webpack_public_path__ + "img/27. Left.c011dfea.svg";